import React from 'react';
import { SvgIcon } from '@material-ui/core';

const Commercial = (props) => {
  return (
    <SvgIcon {...props} width='27.219' height='27.105' viewBox='0 0 27.219 27.105'>
      <path
        id='Path_4118'
        data-name='Path 4118'
        d='M27.547,2H2.433A.433.433,0,0,0,2,2.433V27.547a.433.433,0,0,0,.433.433H27.547a.433.433,0,0,0,.433-.433V2.433A.433.433,0,0,0,27.547,2Zm-.433.866v2.6H2.866v-2.6ZM2.866,27.114V6.33H27.114V27.114Z'
        transform='translate(-2 -2)'
      />
      <path id='Path_4119' data-name='Path 4119' d='M6,6h.866v.866H6Z' transform='translate(-4.268 -4.268)' />
      <path id='Path_4120' data-name='Path 4120' d='M10,6h.866v.866H10Z' transform='translate(-6.535 -4.268)' />
      <path id='Path_4121' data-name='Path 4121' d='M14,6h.866v.866H14Z' transform='translate(-8.805 -4.268)' />
      <path id='Path_4122' data-name='Path 4122' d='M32,6H43.258v.866H32Z' transform='translate(-19.01 -4.268)' />
      <path
        id='Path_4123'
        data-name='Path 4123'
        d='M29.052,30.557a.433.433,0,0,0-.279-.4l-4.621-1.76,4.621-1.76a.433.433,0,0,0,0-.81l-4.621-1.76,4.621-1.76a.433.433,0,0,0,0-.81L19.68,18.028a.43.43,0,0,0-.308,0l-9.093,3.464a.433.433,0,0,0,0,.81l4.621,1.76-4.621,1.76a.433.433,0,0,0,0,.81l4.621,1.76-4.621,1.76a.433.433,0,0,0,0,.81l9.093,3.464a.436.436,0,0,0,.308,0l9.093-3.464A.433.433,0,0,0,29.052,30.557ZM19.526,18.9l7.877,3-7.877,3-7.877-3Zm-3.41,5.629,3.256,1.24a.43.43,0,0,0,.308,0l3.256-1.24,4.467,1.7-7.877,3-7.877-3Zm3.41,9.033-7.877-3,4.467-1.7,3.256,1.24a.43.43,0,0,0,.308,0l3.256-1.24,4.467,1.7Z'
        transform='translate(-6.535 -11.071)'
      />
      <path
        id='Path_4124'
        data-name='Path 4124'
        d='M8.471,17.757,7.045,16.331l1.426-1.426-.612-.612L6.127,16.025a.433.433,0,0,0,0,.612l1.732,1.732Z'
        transform='translate(-4.268 -8.97)'
      />
      <path
        id='Path_4125'
        data-name='Path 4125'
        d='M52.905,49.293l-.612.612,1.426,1.426-1.426,1.426.612.612,1.732-1.732a.433.433,0,0,0,0-.612Z'
        transform='translate(-30.516 -28.814)'
      />
      <path id='Path_4126' data-name='Path 4126' d='M48,55h.866v.866H48Z' transform='translate(-28.082 -32.051)' />
      <path id='Path_4127' data-name='Path 4127' d='M44,55h.866v.866H44Z' transform='translate(-25.814 -32.051)' />
      <path id='Path_4128' data-name='Path 4128' d='M40,55h.866v.866H40Z' transform='translate(-23.545 -32.051)' />
    </SvgIcon>
  );
};

export default Commercial;
